export default "__VITE_ASSET__1be0af8a__"